import { sva } from '@onbeam/business-styled-system/css';

export const drawerStyles = sva({
  className: 'drawer',
  slots: [
    'overlay',
    'root',
    'content',
    'thumb',
    'title',
    'description',
    'close',
  ],
  base: {
    overlay: {
      position: 'fixed',
      top: '0',
      right: '0',
      bottom: '0',
      left: '0',
      zIndex: 50,
      animationName: 'fadeIn',
      animationDuration: 'normal',
      bg: '[#2A303763]',
      backdropFilter: '[blur(4px)]',

      _closed: {
        animationName: 'fadeOut',
      },
    },
    root: {
      position: 'fixed',
      zIndex: 50,
      bg: 'mono.primaryFg',
      color: 'mono.primaryBg',
      shadow: 'md',

      '&[data-vaul-drawer-direction=right]': {
        shadow: '[token(shadows.md), inset 1px 0 0 0 token(colors.opacity.md)]',
        right: '0',
      },
      '&[data-vaul-drawer-direction=left]': {
        shadow:
          '[token(shadows.md), inset -1px 0 0 0 token(colors.opacity.md)]',
        left: '0',
      },
      '&[data-vaul-drawer-direction=right], &[data-vaul-drawer-direction=left]':
        {
          insetY: '0',
          mdDown: {
            insetX: '0',
          },
          md: {
            maxW: '[30rem]',
            w: '3/4',
          },
        },
      '&[data-vaul-drawer-direction=top]': {
        roundedBottom: 'lg',
        top: '0',
        mb: 'auto',
      },
      '&[data-vaul-drawer-direction=bottom]': {
        roundedTop: 'lg',
        bottom: '0',
        mt: 'auto',
      },
      '&[data-vaul-drawer-direction=top], &[data-vaul-drawer-direction=bottom]':
        {
          border: '1px solid',
          borderColor: 'opacity.md',
          insetX: '0',
        },
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      overflowY: 'auto',
      h: 'full',

      '.drawerContent[data-vaul-drawer-direction=right] &, .drawerContent[data-vaul-drawer-direction=left] &':
        {
          p: '8',
          pt: '20',
        },
      '.drawerContent[data-vaul-drawer-direction=top] &, .drawerContent[data-vaul-drawer-direction=bottom] &':
        {
          px: '6',
          pb: '6',
          pt: '10',
          maxH: '[75vh]',
        },
      '.drawerContent[data-vaul-drawer-direction=bottom] &': {
        pt: '3',
      },
    },
    thumb: {
      bg: 'mono.quinary',
      h: '[0.375rem]',
      rounded: 'full',
      w: '[4rem]',
      mx: 'auto',
      mb: '6',
      flexShrink: 0,
    },
    title: {
      // TODO: Not published yet
      // _hidden: { srOnly: true },
      '&[data-hidden="true"]': {
        srOnly: true,
      },
    },
    description: {
      // _hidden: { srOnly: true },
      '&[data-hidden="true"]': {
        srOnly: true,
      },
    },
    close: {
      position: 'absolute',
      top: '4',
      right: '4',
      rounded: 'full',
      bg: 'mono.quartenery',
      color: 'mono.primaryBg',
      p: '2.5',
      cursor: 'pointer',
      outline: 'none',
      transition: 'colors',
      transitionProperty: 'colors, box-shadow',
      zIndex: '5',

      _focusActive: {
        shadow: 'outline',
        bg: 'mono.quinary',
      },
      _supportsHover: {
        _hover: {
          bg: 'mono.quinary',
        },
      },
    },
  },
});
